import type { RouteRecordRaw } from 'vue-router';
import RouteLayout from '../RouteLayout.vue';

export const foodsRoutes: RouteRecordRaw = {
  path: 'foods',
  component: RouteLayout,
  children: [
    {
      path: '',
      name: 'tabs-foods',
      component: () => import('@/views/FoodsPage.vue'),
    },
    {
      path: 'recipes',
      name: 'tabs-foods-recipes',
      component: () => import('@/views/RecipesPage.vue'),
    },
    {
      path: 'recipes/new',
      name: 'recipes-create',
      component: () => import('@/components/RecipeWizard.vue'),
    },
    {
      path: 'recipes/:id/edit',
      name: 'recipes-edit',
      component: () => import('@/components/RecipeWizard.vue'),
    },
    {
      path: 'custom',
      name: 'tabs-foods-custom',
      component: () => import('@/views/CustomFoods.vue'),
    },
    {
      path: ':id',
      name: 'food-detail',
      component: () => import('@/views/FoodDetailPage.vue'),
    },
  ],
};
